<script setup lang="ts">
import { computed } from 'vue';
// 优势项类型
interface AdvantageItem {
  title: string;
  desc: string;
  icon: string;
  briefBack: string;
}

// 产品优势模块
interface Advantages {
  title: string;
  background: string;
  list: AdvantageItem[];
}

interface Content {
  content: Advantages;
}

interface ExtraTitleStyle {
  [key: string]: string;
}

const props = withDefaults(defineProps<Content & { extraTitleStyle?: ExtraTitleStyle }>(), {
  content: () => ({
    title: '产品优势',
    background: '/images/advantage-bg.png',
    list: [
      {
        title: '高效性能',
        desc: '采用先进的技术架构，确保系统运行稳定高效，提升用户体验',
        icon: '/images/advantage-icon-1.png',
        briefBack: '/images/advantage-icon-1.png',
      },
      {
        title: '安全可靠',
        desc: '多重安全防护机制，保障数据安全，让您使用无忧',
        icon: '/images/advantage-icon-2.png',
        briefBack: '/images/advantage-icon-1.png',
      },
      {
        title: '易于扩展',
        desc: '模块化设计，支持灵活扩展，满足不同业务需求',
        icon: '/images/advantage-icon-3.png',
        briefBack: '/images/advantage-icon-1.png',
      }
    ]
  }),
  extraTitleStyle: () => ({})
})

const imagesListForMobile = computed(() => {
  return props.content.list.map(item => item.briefBack);
});
</script>

<template>
  <section class="relative w-full ml:py-9.4rem page-advantage max-ml:py-0rem  max-ml:h-[auto] "
    :style="{ backgroundImage: `url(${props.content.background})` }">
    <PageContentCenter class="text-[#272E3B] relative max-ml:w-100%">
      <PageAdvanceTitle class="max-ml:mb-3rem" :title="props.content.title" :style="props.extraTitleStyle" />
      <ul class="flex justify-center gap-2.44rem ml:mt-2rem max-ml:flex-col max-ml:items-center max-ml:hidden">
        <li v-for="item in props.content.list"
          class="page-advantage-item relative max-ml:!w-auto relative max-ml:mb-20px">
          <Pic :src="item.briefBack" class="relative  max-ml:h-auto"></Pic>
        </li>
      </ul>
      <div class="hidden max-ml:block">
        <v-carousel class="page-advantage-mobile-carousel" interval="3000" cycle hide-delimiters :show-arrows="false">
          <v-carousel-item v-for="imageItem in imagesListForMobile">
            <Pic useOriginUrl class="" :src="imageItem" :style="{ width: '100%', height: 'auto', maxHeight: '90%' }"
              alt="" />
          </v-carousel-item>
        </v-carousel>
        <!-- <TinySwiperImages :source="imagesListForMobile" :picStyle="{ width: '100%', height: 'auto' }" /> -->
      </div>
    </PageContentCenter>
  </section>
</template>

<style lang="scss" scoped>
.page-advantage {
  position: relative;
  background-position: center;
  background-size: cover;

}
</style>
